import { render, staticRenderFns } from "./seeChoose.vue?vue&type=template&id=1552c5e4&scoped=true&"
import script from "./seeChoose.vue?vue&type=script&lang=js&"
export * from "./seeChoose.vue?vue&type=script&lang=js&"
import style0 from "./seeChoose.vue?vue&type=style&index=0&id=1552c5e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1552c5e4",
  null
  
)

export default component.exports